<script lang="ts">
  import { haptic } from "../lib/tg";

  let {
    onpress,
    recording = false,
    busy = false,
  }: {
    onpress?: () => void;
    recording?: boolean;
    busy?: boolean;
  } = $props();

  function handleClick() {
    if (busy) return;
    haptic("medium");
    onpress?.();
  }
</script>

<button
  class="mic"
  class:recording
  class:busy
  onclick={handleClick}
  aria-label={recording ? "Остановить запись" : "Голосовая команда Квину"}
  disabled={busy}
>
  {#if busy}
    <div class="spinner"></div>
  {:else}
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
      stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 2a3 3 0 00-3 3v7a3 3 0 006 0V5a3 3 0 00-3-3z"/>
      <path d="M19 10v2a7 7 0 01-14 0v-2"/>
      <line x1="12" y1="19" x2="12" y2="23"/>
    </svg>
  {/if}
</button>

<style>
  .mic {
    position: fixed;
    right: 18px;
    bottom: calc(20px + var(--safe-bottom, 0px));
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: var(--ember);
    color: #fff;
    box-shadow: var(--shadow-lg);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
    transition: transform 120ms ease, background 200ms ease;
  }
  .mic:active { transform: scale(0.94); }
  .mic.busy { opacity: 0.7; cursor: wait; }
  .mic svg { width: 24px; height: 24px; }

  .mic.recording {
    background: var(--danger);
    animation: pulse 1.4s ease-in-out infinite;
  }
  @keyframes pulse {
    0%, 100% { box-shadow: 0 0 0 0 rgba(209, 87, 78, 0.55), var(--shadow-lg); }
    50%      { box-shadow: 0 0 0 12px rgba(209, 87, 78, 0), var(--shadow-lg); }
  }

  .spinner {
    width: 20px; height: 20px;
    border-radius: 50%;
    border: 2.5px solid rgba(255,255,255,0.35);
    border-top-color: #fff;
    animation: spin 0.7s linear infinite;
  }
  @keyframes spin { to { transform: rotate(360deg); } }
</style>
